<template>
  <div class="el-input-time">
    <el-select
      v-if="!this.fixUnit"
      v-model="timeUnitValue"
      :disabled="disabled"
	  @change="detectUnitChange"
      placeholder="Select"
    >
      <el-option
        v-for="item in unitOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <el-input-number
      v-model="numberValue"
      :min="1"
      :max="maxValue"
      :disabled="disabled"
      controls-position="right"
    />
    <span class="input-num-unit">{{ timeUnit }}</span>
  </div>
</template>

<script>
const MINUTE = 1,
	HOUR = 60,
	DAY = 60 * 24;

export default {
	name: "ElInputTime",
	props: {
		value: {},
		fixUnit: {},
		disabled: {
			default: false,
			type: Boolean,
		},
		maxDayLimit: {
			type: Number,
			default: Infinity
		}
	},
	data() {
		return {
			unitOptions: [
				{
					value: MINUTE,
					label: "분",
				},
				{
					value: HOUR,
					label: "시간",
				},
				{
					value: DAY,
					label: "일",
				},
			],
			currentValue: 0,
			timeUnitValue: 1,
			numberValue: 1,
		};
	},
	computed: {
		timeUnit() {
			return this.unitOptions.find(unit => unit.value === this.timeUnitValue)
				.label;
		},
		maxValue() {
			if (this.timeUnitValue === MINUTE) {
				return 59;
			} else if (this.timeUnitValue === HOUR) {
				return 23;
			} else {
				return this.maxDayLimit;
			}
		},
	},
	watch: {
		timeUnitValue(value) {
			this.currentValue = value * this.numberValue;
			this.$emit("input", this.currentValue);
		},
		numberValue(value) {
			this.currentValue = value * this.timeUnitValue;
			this.$emit("input", this.currentValue);
		},
		value: {
			immediate: true,
			handler(value) {
				if (value === this.currentValue) {
					return;
				}

				if (this.fixUnit) {
					this.numberValue = value / this.fixUnit;
					return (this.timeUnitValue = this.fixUnit);
				}

				if (value % DAY === 0) {
					this.numberValue = value / DAY;
					return (this.timeUnitValue = DAY);
				}

				if (value % HOUR === 0) {
					this.numberValue = value / HOUR;
					return (this.timeUnitValue = HOUR);
				}

				this.numberValue = value / MINUTE;
				return (this.timeUnitValue = MINUTE);
			},
		},
	},
	methods:{
		detectUnitChange(){
			this.numberValue = 1;
		}
	}
};
</script>

<style lang="scss">
@import "../../scss/element-custom/components/el-input-time.scss";
</style>
